import React from 'react';

export default function ListItemPlus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46446 2.96446C2 4.42894 2 6.78596 2 11.5C2 16.214 2 18.5711 3.46446 20.0356C4.92894 21.5 7.28596 21.5 12 21.5C16.714 21.5 19.0711 21.5 20.5356 20.0356C22 18.5711 22 16.214 22 11.5C22 6.78596 22 4.42894 20.5356 2.96446C19.0711 1.5 16.714 1.5 12 1.5C7.28596 1.5 4.92894 1.5 3.46446 2.96446ZM12 6.5C12.436 6.5 12.7895 6.85346 12.7895 7.28947V10.7105H16.2105C16.6465 10.7105 17 11.064 17 11.5C17 11.936 16.6465 12.2895 16.2105 12.2895H12.7895V15.7105C12.7895 16.1465 12.436 16.5 12 16.5C11.564 16.5 11.2105 16.1465 11.2105 15.7105V12.2895H7.78947C7.35346 12.2895 7 11.936 7 11.5C7 11.064 7.35346 10.7105 7.78947 10.7105H11.2105V7.28947C11.2105 6.85346 11.564 6.5 12 6.5Z"
        fill="white"
      />
    </svg>
  );
}
